"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9748],{

/***/ 43392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PromoterHeader_PromoterHeader; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Avatar/index.js + 2 modules
var Avatar = __webpack_require__(78045);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PromoterHeader/PromoterHeader.style.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22;







var BlueStrip = styled_components_browser_esm/* default.div */.ZP.div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: ", ";\n  height: 60px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 8;\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm/* getBackgroundColor */.dF)('primary')(props);
});
var CapitalizedText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-transform: capitalize;\n"])));
var DefaultIcon = (0,styled_components_browser_esm/* default */.ZP)(build_esm/* Icon */.JO$)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fill: ", ";\n"])), function (_ref) {
  var color = _ref.color;
  return color;
});
var PromoterAvatar = (0,styled_components_browser_esm/* default */.ZP)(Avatar/* default */.Z)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: ", ";\n  width: ", ";\n  margin-right: ", ";\n  flex: 0 0 auto;\n\n  & svg {\n    height: ", ";\n    width: ", ";\n    fill: ", ";\n    color: ", ";\n  }\n\n  ", "\n"])), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.margin || '16px';
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, (0,stereo_ui_styles_build_esm/* themeGet */.R)('palette.primary.base'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('palette.primary.base'), function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile && (0,styled_components_browser_esm/* css */.iv)(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n      border: 4px solid ", ";\n      display: flex;\n      z-index: 9;\n      align-items: center;\n      justify-content: center;\n    "])), (0,stereo_ui_styles_build_esm/* getBackgroundColor */.dF)('white'));
});
var PromoterAvatarContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 0 0 auto;\n  min-width: 116px;\n"])));
var PromoterContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 100%;\n  overflow: hidden;\n  width: 610px;\n  justify-self: center;\n\n  ", "\n"])), function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile && (0,styled_components_browser_esm/* css */.iv)(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n      display: flex;\n      flex-direction: column;\n      width: 100%;\n    "])));
});
var PromoterData = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-direction: column;\n  width: calc(100% - 176px);\n\n  ", "\n"])), function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile && (0,styled_components_browser_esm/* css */.iv)(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: 100%;\n      padding: 8px;\n    "])));
});
var PromoterDataContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)(_templateObject11 || (_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 1;\n  flex-direction: column;\n"])));
var PromoterDescriptionContainer = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)(_templateObject12 || (_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  line-height: 1.4em;\n  max-width: 400px;\n  width: 100%;\n\n  ", "\n"])), function (_ref5) {
  var isOpen = _ref5.isOpen;
  return !isOpen && (0,styled_components_browser_esm/* css */.iv)(_templateObject13 || (_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    "])));
});
var PromoterHeaderContainer = styled_components_browser_esm/* default.section */.ZP.section(_templateObject14 || (_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  box-shadow: 0px 2px 5px 0px rgba(29, 43, 122, 0.15);\n  display: flex;\n  justify-content: center;\n  margin-bottom: 4px;\n  width: 100%;\n  background: ", ";\n"])), (0,stereo_ui_styles_build_esm/* getBackgroundColor */.dF)('white'));
var PromoterHeaderMobileWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)(_templateObject15 || (_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  background: ", ";\n"])), (0,stereo_ui_styles_build_esm/* getBackgroundColor */.dF)('white'));
var PromoterWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)(_templateObject16 || (_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  max-width: 1366px;\n  padding: 24px;\n"])));
var SeeMoreButton = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)(_templateObject17 || (_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n  appearance: none;\n  background: none;\n  border: none;\n  color: ", ";\n  cursor: pointer;\n  display: flex;\n  width: 10ch;\n  margin-top: 8px;\n\n  svg {\n    fill: ", ";\n    transition: transform 0.5s ease;\n  }\n\n  ", "\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm/* getTextColor */.uu)('primary')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm/* getTextColor */.uu)('primary')(props);
}, function (_ref6) {
  var isOpen = _ref6.isOpen;
  return isOpen && (0,styled_components_browser_esm/* css */.iv)(_templateObject18 || (_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n      svg {\n        transform: rotate(180deg);\n      }\n    "])));
});
var ShareIcon = (0,styled_components_browser_esm/* default */.ZP)(DefaultIcon)(_templateObject19 || (_templateObject19 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var SocialIcon = (0,styled_components_browser_esm/* default */.ZP)(DefaultIcon)(_templateObject20 || (_templateObject20 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var SocialShareContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)(_templateObject21 || (_templateObject21 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n"])), function (_ref7) {
  var isMobile = _ref7.isMobile;
  return isMobile && (0,styled_components_browser_esm/* css */.iv)(_templateObject22 || (_templateObject22 = (0,taggedTemplateLiteral/* default */.Z)(["\n      position: relative;\n      top: -10px;\n      flex-wrap: wrap-reverse;\n      justify-content: flex-end;\n    "])));
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PromoterHeader/components/PromoterHeaderComponents/PromoterDescription.js




var PromoterDescription = function PromoterDescription(_ref) {
  var description = _ref.description,
    descriptionLimit = _ref.descriptionLimit;
  if (!description) {
    return null;
  }
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    showFullDescription = _useState2[0],
    setShowFullDescription = _useState2[1];
  var isLongDescription = (description == null ? void 0 : description.length) > descriptionLimit;
  return react.createElement(react.Fragment, null, react.createElement(PromoterDescriptionContainer, {
    "data-testid": "promoter-description",
    "aria-expanded": showFullDescription,
    fontSize: 1,
    isOpen: !isLongDescription || showFullDescription,
    mt: 2
  }, description), isLongDescription && react.createElement(SeeMoreButton, {
    "data-testid": "promoter-description-button",
    as: "button",
    fontSize: 1,
    isOpen: showFullDescription,
    onClick: function onClick() {
      return setShowFullDescription(function (prev) {
        return !prev;
      });
    }
  }, react.createElement("span", null, "Ver mais"), react.createElement("span", null, react.createElement(ShareIcon, {
    name: "ChevronDown",
    color: "primary",
    height: 16,
    ml: 1,
    width: 16
  }))));
};
 false ? 0 : void 0;
PromoterDescription.defaultProps = {
  description: null,
  descriptionLimit: 60
};
/* harmony default export */ var PromoterHeaderComponents_PromoterDescription = (PromoterDescription);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../modules/build/esm/commons/isValidStaticProp.js
var isValidStaticProp = __webpack_require__(68909);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PromoterHeader/components/PromoterHeaderComponents/SocialShare.js






var createSocialMedia = {
  email: function email(username) {
    return {
      href: "Mailto:".concat(username),
      icon: 'MailOutline',
      name: 'Email'
    };
  },
  instagram: function instagram(username) {
    return {
      href: "https://instagram.com/".concat(username),
      icon: 'Instagram',
      name: 'Instagram'
    };
  },
  telegram: function telegram(username) {
    return {
      href: "https://t.me/".concat(username),
      icon: 'Telegram',
      name: 'Telegram'
    };
  },
  tiktok: function tiktok(username) {
    return {
      href: "https://www.tiktok.com/@".concat(username),
      icon: 'Tiktok',
      name: 'Tiktok'
    };
  },
  whatsapp: function whatsapp(username) {
    return {
      href: "https://wa.me/55".concat(username.replace('-', '')),
      icon: 'WhatsApp',
      name: 'WhatsApp'
    };
  }
};
var SocialShare = function SocialShare(_ref) {
  var promoterData = _ref.promoterData,
    isMobile = _ref.isMobile;
  if (!promoterData) {
    return null;
  }
  var _useState = (0,react.useState)([]),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    sectionSocial = _useState2[0],
    setSectionSocial = _useState2[1];
  (0,react.useEffect)(function () {
    var _promoterData$socialN;
    var tempSectionSocial = [];
    if (promoterData.phone) tempSectionSocial.push(createSocialMedia.whatsapp(promoterData.phone));
    if (promoterData.email) tempSectionSocial.push(createSocialMedia.email(promoterData.email));
    promoterData == null ? void 0 : (_promoterData$socialN = promoterData.socialNetworks) == null ? void 0 : _promoterData$socialN.forEach(function (_ref2) {
      var name = _ref2.name,
        username = _ref2.username;
      if (username) tempSectionSocial.push(createSocialMedia[name](username));
    });
    setSectionSocial(tempSectionSocial);
  }, [promoterData]);
  return react.createElement(SocialShareContainer, {
    isMobile: isMobile,
    "data-testid": "social-share"
  }, sectionSocial.map(function (_ref3, index) {
    var href = _ref3.href,
      icon = _ref3.icon,
      name = _ref3.name,
      _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? 'primary' : _ref3$color,
      _ref3$iconColor = _ref3.iconColor,
      iconColor = _ref3$iconColor === void 0 ? '#fff' : _ref3$iconColor,
      customColor = _ref3.customColor;
    return (0,isValidStaticProp/* default */.Z)(href) && react.createElement(Button/* default */.Z, {
      key: "button-".concat(name),
      as: "a",
      title: name,
      centered: false,
      color: color,
      customColor: customColor,
      "data-testid": "social-".concat(name.toLowerCase(), "-button"),
      disabled: false,
      full: false,
      href: href,
      target: "_blank",
      rel: "noopener",
      variation: "fill",
      rounded: true,
      size: "auto",
      height: "28px",
      width: "28px",
      mt: 2,
      mr: sectionSocial.length - 1 !== index ? 2 : 0
    }, react.createElement(ShareIcon, {
      name: icon,
      color: iconColor,
      width: 16,
      height: 16
    }));
  }));
};
 false ? 0 : void 0;
SocialShare.defaultProps = {
  isMobile: false,
  promoterData: null
};
/* harmony default export */ var PromoterHeaderComponents_SocialShare = (SocialShare);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PromoterHeader/components/PromoterHeaderComponents/index.js


;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PromoterHeader/components/PromoterHeaderDesktop/PromoterHeaderDesktop.js






var PromoterHeaderDesktop = function PromoterHeaderDesktop(_ref) {
  var staticProps = _ref.staticProps,
    promoterData = _ref.promoterData;
  var store = staticProps.store,
    descriptionLimit = staticProps.descriptionLimit;
  return react.createElement(PromoterWrapper, {
    "data-testid": "promoter-header-desktop",
    width: 1
  }, react.createElement(PromoterContainer, null, react.createElement(Flex/* default */.Z, {
    alignItems: "flex-start"
  }, react.createElement(PromoterAvatarContainer, null, react.createElement(PromoterAvatar, {
    src: store == null ? void 0 : store.image,
    alt: "Imagem de perfil do Divulgador",
    size: "102px"
  })), react.createElement(PromoterDataContainer, {
    justifyContent: "center",
    height: "100%"
  }, react.createElement(CapitalizedText, {
    fontSize: 4,
    fontWeight: "bold",
    textTransform: "capitalize",
    lineHeight: "16px"
  }, store == null ? void 0 : store.name), react.createElement(Text/* default */.Z, {
    color: "primary",
    fontSize: 2,
    mt: 2,
    lineHeight: "16px"
  }, "Influenciador Magalu"), react.createElement(PromoterHeaderComponents_PromoterDescription, {
    description: promoterData.description,
    descriptionLimit: descriptionLimit
  }), react.createElement(PromoterHeaderComponents_SocialShare, {
    promoterData: promoterData
  })))));
};
 false ? 0 : void 0;
PromoterHeaderDesktop.defaultProps = {
  promoterData: null,
  staticProps: {}
};
PromoterHeaderDesktop.ssr = false;
PromoterHeaderDesktop.displayName = 'PromoterHeaderDesktop';
/* harmony default export */ var PromoterHeaderDesktop_PromoterHeaderDesktop = (PromoterHeaderDesktop);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PromoterHeader/components/PromoterHeaderDesktop/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PromoterHeader/components/PromoterHeaderMobile/PromoterHeaderMobile.js






var PromoterHeaderMobile = function PromoterHeaderMobile(_ref) {
  var staticProps = _ref.staticProps,
    promoterData = _ref.promoterData;
  var store = staticProps.store,
    descriptionLimit = staticProps.descriptionLimit;
  return react.createElement(PromoterHeaderMobileWrapper, {
    "data-testid": "promoter-header-mobile",
    p: 1,
    width: 1
  }, react.createElement(BlueStrip, null), react.createElement(Flex/* default */.Z, {
    alignItems: "flex-start",
    justifyContent: "space-between"
  }, react.createElement(PromoterContainer, {
    isMobile: true
  }, react.createElement(Flex/* default */.Z, {
    alignItems: "flex-end",
    justifyContent: "space-between",
    p: 2,
    width: 1,
    minHeight: "110px"
  }, react.createElement(PromoterAvatar, {
    isMobile: true,
    "data-testid": "promoter-avatar",
    src: store == null ? void 0 : store.image,
    alt: "Imagem de perfil do Divulgador",
    size: "94px"
  }), react.createElement(PromoterHeaderComponents_SocialShare, {
    promoterData: promoterData,
    isMobile: true
  })), react.createElement(PromoterData, {
    isMobile: true
  }, react.createElement(CapitalizedText, {
    fontSize: 4,
    fontWeight: "bold"
  }, store == null ? void 0 : store.name), react.createElement(Text/* default */.Z, {
    color: "primary",
    fontSize: 2,
    fontWeight: "bold",
    mt: 3
  }, "Influenciador Magalu"), react.createElement(PromoterHeaderComponents_PromoterDescription, {
    description: promoterData.description,
    descriptionLimit: descriptionLimit
  })))));
};
 false ? 0 : void 0;
PromoterHeaderMobile.defaultProps = {
  promoterData: null,
  staticProps: {}
};
PromoterHeaderMobile.ssr = false;
PromoterHeaderMobile.displayName = 'PromoterHeaderMobile';
/* harmony default export */ var PromoterHeaderMobile_PromoterHeaderMobile = (PromoterHeaderMobile);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PromoterHeader/components/PromoterHeaderMobile/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PromoterHeader/components/PromoterHeaderMinimal/PromoterHeaderMinimal.js








var PromoterHeaderMinimal = function PromoterHeaderMinimal(_ref) {
  var staticProps = _ref.staticProps,
    structure = _ref.structure;
  var store = staticProps.store,
    isMobile = staticProps.isMobile,
    minimalButton = staticProps.minimalButton;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var renderButton = function renderButton(render) {
    if (!minimalButton || !render) return null;
    var openShareLinksModal = function openShareLinksModal() {
      publish('sharelinksbutton:click');
      publish('pmd:sharelinks:generate:link:click', {
        pageType: structure == null ? void 0 : structure.name,
        productId: structure == null ? void 0 : structure.route.productId,
        productName: isMobile ? structure == null ? void 0 : structure.route.productSlug : structure == null ? void 0 : structure.route.slug
      });
    };
    var buttonProps = {
      centered: true,
      'data-testid': "phm-button-".concat(isMobile ? 'mobile' : 'desktop'),
      full: !!isMobile,
      ml: 'auto',
      mt: isMobile ? 3 : 0,
      onClick: openShareLinksModal,
      startIcon: minimalButton == null ? void 0 : minimalButton.icon,
      type: 'submit',
      uppercase: false,
      variation: 'primary'
    };
    return react.createElement(Button/* default */.Z, buttonProps, minimalButton == null ? void 0 : minimalButton.text);
  };
  return react.createElement(Grid/* default */.Z, {
    gridTemplateColumns: "minmax(8px, 1fr) minmax(auto, 1366px) minmax(8px, 1fr)",
    gridTemplateRows: "minmax(86px, auto)",
    gridTemplateAreas: " '. content .' ",
    style: {
      alignItems: 'center'
    },
    "data-testid": "promoter-header-minimal"
  }, react.createElement(Grid/* default */.Z, {
    gridArea: "content",
    padding: "16px 0"
  }, react.createElement(Flex/* default */.Z, {
    alignItems: "center",
    gap: 3
  }, react.createElement(PromoterAvatar, {
    src: store == null ? void 0 : store.image,
    alt: "Imagem de perfil do Divulgador",
    size: "50px",
    margin: "0"
  }), react.createElement(Flex/* default */.Z, {
    flexDirection: "column",
    justifyContent: "center",
    height: "50px",
    gap: 2
  }, react.createElement(CapitalizedText, {
    fontSize: 4,
    fontWeight: "bold"
  }, store == null ? void 0 : store.name), react.createElement(Text/* default */.Z, {
    fontSize: 2
  }, "Influenciador Magalu")), renderButton(!isMobile)), renderButton(!!isMobile)));
};
 false ? 0 : void 0;
PromoterHeaderMinimal.defaultProps = {
  staticProps: {},
  structure: {}
};
/* harmony default export */ var PromoterHeaderMinimal_PromoterHeaderMinimal = (PromoterHeaderMinimal);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PromoterHeader/components/PromoterHeaderMinimal/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PromoterHeader/components/PromoterHeaderByType/PromoterHeaderByType.js

var _excluded = ["headerType"];





var PromoterHeaderByType = function PromoterHeaderByType(_ref) {
  var headerType = _ref.headerType,
    rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  var mappedPromoterHeader = {
    desktop: PromoterHeaderDesktop_PromoterHeaderDesktop,
    minimal: PromoterHeaderMinimal_PromoterHeaderMinimal,
    mobile: PromoterHeaderMobile_PromoterHeaderMobile
  };
  var CardWrapper = mappedPromoterHeader[headerType];
  return react.createElement(CardWrapper, rest);
};
 false ? 0 : void 0;
PromoterHeaderByType.defaultProps = {
  headerType: 'minimal'
};
/* harmony default export */ var PromoterHeaderByType_PromoterHeaderByType = (PromoterHeaderByType);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PromoterHeader/components/PromoterHeaderByType/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PromoterHeader/PromoterHeader.js







var PromoterHeader = function PromoterHeader(_ref) {
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var headerType = staticProps.headerType,
    store = staticProps.store,
    sticky = staticProps.sticky;
  var props = {
    staticProps: staticProps,
    structure: structure
  };
  var node = (0,react.useRef)(null);
  var promoterBusinessCardData = {};
  (0,react.useEffect)(function () {
    var _node$current;
    var parent = (_node$current = node.current) == null ? void 0 : _node$current.parentNode.style;
    if (sticky && parent) {
      parent.position = 'sticky';
      parent.top = 0;
      parent['z-index'] = 100;
    }
  }, []);
  if (headerType !== 'minimal') {
    promoterBusinessCardData = (0,esm.usePromoterBusinessCard)({
      storeId: store == null ? void 0 : store.id
    }).promoterBusinessCardData;
  }
  return react.createElement(PromoterHeaderContainer, {
    ref: node
  }, react.createElement(PromoterHeaderByType_PromoterHeaderByType, (0,esm_extends/* default */.Z)({
    headerType: headerType,
    promoterData: promoterBusinessCardData
  }, props)));
};
 false ? 0 : void 0;
PromoterHeader.ssr = true;
PromoterHeader.displayName = 'PromoterHeader';
/* harmony default export */ var PromoterHeader_PromoterHeader = ((0,withLayoutProps/* default */.Z)(PromoterHeader));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/PromoterHeader/index.js


/***/ }),

/***/ 78449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ QuestionConfirm_QuestionConfirm; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var utils_build_esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../modules/build/esm/hooks/useUserData.js
var useUserData = __webpack_require__(16666);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuestionConfirm/QuestionConfirm.styles.js

var _templateObject;


var DialogContainer = (0,styled_components_browser_esm/* default */.ZP)(Dialog/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: ", ";\n"])), function (_ref) {
  var position = _ref.position;
  return position === 'bottom' ? '100%' : '30%';
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuestionConfirm/QuestionConfirm.js



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }









var QuestionConfirm = function QuestionConfirm(_ref) {
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    showConfirm = _React$useState2[0],
    setShowConfirm = _React$useState2[1];
  var _React$useState3 = react.useState(''),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    chars = _React$useState4[0],
    setChars = _React$useState4[1];
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe,
    publish = _usePublisher.publish,
    unsubscribe = _usePublisher.unsubscribe;
  var position = staticProps.modal.position;
  var _useQuestions = (0,build_esm.useQuestions)(),
    createQuestion = _useQuestions.createQuestion;
  var handleConfirm = function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
      var _structure$route, _structure$route2;
      var user, _yield$createQuestion, data, error;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,useUserData/* default */.Z)({
              structure: structure
            });
          case 2:
            user = _context.sent;
            publish('question-confirm:click', {
              userId: user.id
            });
            publish('question-confirm:clean');
            _context.next = 7;
            return createQuestion({
              questionRequest: {
                question: chars,
                user: {
                  customerId: user.id,
                  email: user.email,
                  name: user.name
                },
                variationId: (structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.productId) || (structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.questionVariationId)
              }
            }, {
              timeout: 8000
            });
          case 7:
            _yield$createQuestion = _context.sent;
            data = _yield$createQuestion.data;
            error = _yield$createQuestion.error;
            setShowConfirm(false);
            publish('question:submit:response', {
              data: data,
              error: error
            });
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleConfirm() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleEdit = function handleEdit(e) {
    publish('question:edit', e);
    setShowConfirm(false);
  };
  var handleCloseFeedback = function handleCloseFeedback() {
    setShowConfirm(false);
  };
  var handleWriteChars = function handleWriteChars(e) {
    setChars(e.target.value.replace('/\n/', ' '));
  };
  var handleRedirectLogin = function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee2() {
      var _ref4,
        logged,
        userLogged,
        _structure$config,
        config,
        nextParam,
        _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _ref4 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, logged = _ref4.logged;
            _context2.t0 = logged;
            if (_context2.t0) {
              _context2.next = 6;
              break;
            }
            _context2.next = 5;
            return (0,useUserData/* default */.Z)({
              structure: structure
            });
          case 5:
            _context2.t0 = _context2.sent.isLogged;
          case 6:
            userLogged = _context2.t0;
            if (!userLogged) {
              _structure$config = structure.config, config = _structure$config === void 0 ? {} : _structure$config;
              nextParam = "&next=".concat(window.location.href);
              (0,utils_build_esm/* routePush */.dY)({
                path: "".concat(config.baseLoginUrl).concat(nextParam),
                spa: false
              });
            }
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleRedirectLogin() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleShowConfirm = function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee3(data) {
      var _ref6, logged;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _ref6 = data || {}, logged = _ref6.logged;
            if (!logged) {
              _context3.next = 5;
              break;
            }
            setShowConfirm(true);
            _context3.next = 7;
            break;
          case 5:
            _context3.next = 7;
            return handleRedirectLogin(data);
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleShowConfirm(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  react.useEffect(function () {
    subscribe('question:form:submit', handleShowConfirm);
    subscribe('question:open:float:modal', handleRedirectLogin);
    subscribe('question:write', handleWriteChars);
    subscribe('question:feedback:close', handleCloseFeedback);
    return function () {
      unsubscribe('question:form:submit', handleShowConfirm);
      unsubscribe('question:open:float:modal', handleRedirectLogin);
      unsubscribe('question:write', handleWriteChars);
      unsubscribe('question:feedback:close', handleCloseFeedback);
    };
  });
  return react.createElement(react.Fragment, null, react.createElement(DialogContainer, {
    portal: true,
    type: "dialog",
    showClose: true,
    visible: showConfirm,
    position: position,
    onClickOutside: function onClickOutside() {
      setShowConfirm(false);
    },
    bg: "background.white"
  }, react.createElement(react.Fragment, null, react.createElement(Text/* default */.Z, {
    fontWeight: "medium",
    mb: 3
  }, "Enviar essa pergunta para a loja?"), react.createElement(Text/* default */.Z, {
    my: 4
  }, "\"".concat(chars, "\"")), react.createElement(Text/* default */.Z, {
    fontWeight: "bold",
    color: "text.primary",
    mb: 4,
    onClick: handleEdit
  }, "Editar"), react.createElement(Button/* default */.Z, {
    "data-testid": "button-confirm",
    full: position === 'bottom',
    centered: true,
    onClick: handleConfirm
  }, react.createElement(Text/* default */.Z, {
    fontWeight: "medium",
    color: "text.white"
  }, "Confirmar")))));
};
 false ? 0 : void 0;
QuestionConfirm.defaultProps = {
  "static": {
    modal: {
      position: 'bottom'
    }
  },
  structure: {}
};
/* harmony default export */ var QuestionConfirm_QuestionConfirm = (QuestionConfirm);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuestionConfirm/index.js


/***/ }),

/***/ 15998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ QuestionFeedback_QuestionFeedback; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hooks/useUserData.js
var useUserData = __webpack_require__(16666);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuestionFeedback/QuestionFeedback.styles.js

var _templateObject;


var DialogContainer = (0,styled_components_browser_esm/* default */.ZP)(Dialog/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: ", ";\n"])), function (_ref) {
  var position = _ref.position;
  return position === 'bottom' ? '100%' : '30%';
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuestionFeedback/QuestionFeedback.js



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }









var QuestionFeedback = function QuestionFeedback(_ref) {
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var _React$useState = react.useState({}),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    error = _React$useState2[0],
    setError = _React$useState2[1];
  var _React$useState3 = react.useState(null),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    response = _React$useState4[0],
    setResponse = _React$useState4[1];
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish,
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var position = staticProps.position;
  var FeedbackData = {
    error: {
      color: 'alert.danger.text',
      icon: 'CloseCircle',
      text: {
        aux: 'Tente novamente',
        title: 'Não foi possível enviar sua pergunta'
      }
    },
    success: {
      color: 'alert.success.text',
      icon: 'DoneCircle',
      text: {
        aux: 'Te avisaremos por email, assim que ela for respondida.',
        title: 'Sua pergunta foi enviada!'
      }
    }
  };
  var handleCloseFeedback = function handleCloseFeedback(e) {
    setError({});
    setResponse(null);
    publish('question-feedback:close', e);
  };
  var handleSubmitResponse = function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee(_ref2) {
      var data, err, _yield$useUserData, userId;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            data = _ref2.data, err = _ref2.error;
            _context.next = 3;
            return (0,useUserData/* default */.Z)({
              structure: structure
            });
          case 3:
            _yield$useUserData = _context.sent;
            userId = _yield$useUserData.userId;
            if (err) {
              setError(err);
              publish('question-feedback:error', {
                error: {
                  message: FeedbackData.error.text.title
                },
                userId: userId
              });
            } else {
              setResponse(data);
            }
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmitResponse(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  react.useEffect(function () {
    subscribe('question:submit:response', handleSubmitResponse);
    return function () {
      unsubscribe('question:submit:response', handleSubmitResponse);
    };
  }, [JSON.stringify(error), JSON.stringify(response)]);
  var errorCode = error == null ? void 0 : error.message;
  var visible = Boolean(errorCode) || Boolean(response);
  return react.createElement(react.Fragment, null, visible && react.createElement(DialogContainer, {
    type: "dialog",
    showClose: true,
    visible: visible,
    onClickOutside: handleCloseFeedback,
    position: position,
    portal: true
  }, react.createElement(react.Fragment, null, react.createElement(Flex/* default */.Z, {
    alignItems: "center",
    justifyContent: "center"
  }, react.createElement(esm/* Icon */.JO$, {
    name: FeedbackData[errorCode ? 'error' : 'success'].icon,
    color: FeedbackData[errorCode ? 'error' : 'success'].color,
    height: 48,
    width: 48,
    "data-testid": "feedback-icon"
  })), react.createElement(Text/* default */.Z, {
    m: 3,
    fontWeight: "medium",
    textAlign: "center"
  }, FeedbackData[errorCode ? 'error' : 'success'].text.title), react.createElement(Text/* default */.Z, {
    m: 3,
    textAlign: "center"
  }, FeedbackData[errorCode ? 'error' : 'success'].text.aux), react.createElement(Flex/* default */.Z, {
    alignItems: "center",
    justifyContent: "center"
  }, react.createElement(Button/* default */.Z, {
    "data-testid": "button-close-feedback",
    full: position === 'bottom',
    centered: true,
    onClick: handleCloseFeedback
  }, react.createElement(Text/* default */.Z, {
    fontWeight: "medium",
    color: "text.white"
  }, "Ok"))))));
};
 false ? 0 : void 0;
QuestionFeedback.defaultProps = {
  "static": {
    modalWidth: '100%',
    position: 'bottom'
  },
  structure: {}
};
QuestionFeedback.ssr = false;
/* harmony default export */ var QuestionFeedback_QuestionFeedback = (QuestionFeedback);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuestionFeedback/index.js


/***/ }),

/***/ 33786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ QuestionFloatForm_QuestionFloatForm; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Input/index.js + 2 modules
var Input = __webpack_require__(29869);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/HiddenLabel/index.js + 2 modules
var HiddenLabel = __webpack_require__(33055);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hooks/index.js + 8 modules
var hooks = __webpack_require__(57508);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/utils.js
var utils = __webpack_require__(77833);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuestionFloatForm/QuestionFloatForm.styles.js

var _templateObject, _templateObject2;




var ButtonFloatContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  position: fixed;\n  z-index: ", ";\n  min-height: 60px;\n  border-top: 1px solid #eee;\n  border-radius: 4px;\n  box-shadow: 0 18px 25px rgb(0 0 0 / 10%);\n  background-color: ", ";\n  box-sizing: border-box;\n  padding: 1rem;\n  bottom: 0;\n"])), function (props) {
  return (0,utils/* themeGet */.R)('zIndices.3')(props);
}, function (props) {
  return (0,utils/* getPaletteColor */.ow)('background.white')(props);
});
var DialogContainer = (0,styled_components_browser_esm/* default */.ZP)(Dialog/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuestionFloatForm/QuestionFloatForm.js



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }










var _require = __webpack_require__(13980),
  shape = _require.shape,
  string = _require.string;
var QuestionFloatForm = function QuestionFloatForm(_ref) {
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var _React$useState = react.useState(false),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    showFloatModal = _React$useState2[0],
    setShowFloatModal = _React$useState2[1];
  var _React$useState3 = react.useState(''),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    chars = _React$useState4[0],
    setChars = _React$useState4[1];
  var _React$useState5 = react.useState({}),
    _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
    userData = _React$useState6[0],
    setUserData = _React$useState6[1];
  var emptyTitle = staticProps.emptyTitle,
    buttonText = staticProps.buttonText;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish,
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var getUserData = react.useCallback((0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
    var data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0,hooks/* useUserData */.v$)({
            structure: structure
          });
        case 2:
          data = _context.sent;
          setUserData(data);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), []);
  var handleEdit = function handleEdit() {
    return setShowFloatModal(true);
  };
  var handleClean = function handleClean() {
    return setChars('');
  };
  react.useEffect(function () {
    subscribe('question-confirm:clean', handleClean);
    subscribe('question:edit', handleEdit);
    getUserData();
    return function () {
      unsubscribe('question-confirm:clean', handleClean);
      unsubscribe('question:edit', handleEdit);
    };
  }, [getUserData]);
  var onClickSubmit = function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee2(e) {
      var _yield$useUserData, id, isLogged;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e.preventDefault();
            setShowFloatModal(false);
            _context2.next = 4;
            return (0,hooks/* useUserData */.v$)({
              structure: structure
            });
          case 4:
            _yield$useUserData = _context2.sent;
            id = _yield$useUserData.id;
            isLogged = _yield$useUserData.isLogged;
            publish('question:form:submit', {
              event: e,
              label: buttonText.authenticated,
              logged: isLogged,
              userId: id
            });
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function onClickSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var _useQuestionInputVali = (0,hooks/* useQuestionInputValidation */.zq)(chars),
    message = _useQuestionInputVali.message,
    textColor = _useQuestionInputVali.textColor,
    inputValid = _useQuestionInputVali.valid;
  return react.createElement(react.Fragment, null, showFloatModal && react.createElement(DialogContainer, {
    type: "dialog",
    showClose: true,
    onClickOutside: function onClickOutside() {
      setShowFloatModal(false);
    },
    portal: true
  }, react.createElement("form", {
    onSubmit: onClickSubmit
  }, react.createElement(Box/* default */.Z, {
    mx: 2,
    mb: 2
  }, react.createElement(Text/* default */.Z, {
    fontSize: [1, 1, 2, 2],
    color: "text.dark",
    fontWeight: "medium",
    my: 3
  }, emptyTitle), react.createElement(HiddenLabel/* default */.Z, {
    title: "digite sua pergunta abaixo",
    htmlFor: "question-input"
  }), react.createElement(Input/* default */.Z, {
    "data-testid": "publish-new-question-float",
    id: "question-input",
    onChange: function onChange(e) {
      setChars(e.target.value);
      publish('question:write', e);
    },
    hasError: chars.length > 0 && !inputValid,
    value: chars,
    placeholder: "Escreva aqui sua d\xFAvida...",
    multiline: true
  })), react.createElement(Text/* default */.Z, {
    fontSize: [0, 0, 1, 1],
    color: textColor,
    mb: 4,
    mx: 2
  }, message), react.createElement(Flex/* default */.Z, {
    alignItems: "center",
    justifyContent: "center",
    mx: 3,
    mb: 2,
    gap: "30%"
  }, react.createElement(Box/* default */.Z, null, react.createElement(Text/* default */.Z, {
    fontSize: [0, 0, 1, 1],
    color: "text.primary",
    center: true,
    onClick: function onClick() {
      return setShowFloatModal(false);
    }
  }, "Cancelar")), react.createElement(Button/* default */.Z, {
    "data-testid": "button-submit-question",
    full: true,
    centered: true,
    disabled: !inputValid
  }, react.createElement(Text/* default */.Z, {
    fontWeight: "medium",
    color: "text.white"
  }, buttonText.authenticated))))), react.createElement(ButtonFloatContainer, {
    visible: true
  }, react.createElement(Button/* default */.Z, {
    variation: "outline",
    "data-testid": "button-write-question",
    full: true,
    centered: true,
    onClick: (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee3() {
      var _yield$useUserData2, isLogged;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            publish(buttonText.event, {
              label: userData.isLogged ? buttonText.authenticated : buttonText.unauthenticated,
              logged: userData.isLogged,
              userId: userData.id
            });
            _context3.next = 3;
            return (0,hooks/* useUserData */.v$)({
              structure: structure
            });
          case 3:
            _yield$useUserData2 = _context3.sent;
            isLogged = _yield$useUserData2.isLogged;
            setShowFloatModal(!!isLogged);
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })),
    disabled: false
  }, react.createElement(Text/* default */.Z, {
    fontWeight: "medium",
    color: "text.primary"
  }, userData.isLogged ? buttonText.authenticated : buttonText.unauthenticated))));
};
 false ? 0 : void 0;
QuestionFloatForm.defaultProps = {};
/* harmony default export */ var QuestionFloatForm_QuestionFloatForm = (QuestionFloatForm);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuestionFloatForm/index.js


/***/ }),

/***/ 96640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ QuestionForm_QuestionForm; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/lodash/debounce.js
var debounce = __webpack_require__(54073);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Input/index.js + 2 modules
var Input = __webpack_require__(29869);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/HiddenLabel/index.js + 2 modules
var HiddenLabel = __webpack_require__(33055);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var build_esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/hooks/index.js + 8 modules
var hooks = __webpack_require__(57508);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuestionForm/QuestionForm.js



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }














var QuestionForm = function QuestionForm(_ref) {
  var _data$product2;
  var staticProps = _ref["static"],
    structure = _ref.structure,
    data = _ref.data;
  var emptyTitle = staticProps.emptyTitle,
    inputHelper = staticProps.inputHelper,
    limit = staticProps.limit,
    seeMore = staticProps.seeMore,
    buttonText = staticProps.buttonText,
    alwaysShow = staticProps.alwaysShow,
    _staticProps$bounceWr = staticProps.bounceWrite,
    bounceWrite = _staticProps$bounceWr === void 0 ? 1000 : _staticProps$bounceWr;
  var _structure$config = structure == null ? void 0 : structure.config,
    domain = _structure$config.domain;
  var _structure$route = structure == null ? void 0 : structure.route,
    categoryId = _structure$route.categoryId,
    slug = _structure$route.slug,
    subCategoryId = _structure$route.subCategoryId;
  var _React$useState = react.useState({}),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    userData = _React$useState2[0],
    setUserData = _React$useState2[1];
  var _ref2 = data.questions || {},
    totalQuestions = _ref2.totalQuestions;
  react.useEffect(function () {
    var getUserData = function () {
      var _ref3 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
        var response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,hooks/* useUserData */.v$)({
                structure: structure
              });
            case 2:
              response = _context.sent;
              setUserData(response);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getUserData() {
        return _ref3.apply(this, arguments);
      };
    }();
    getUserData();
  }, []);
  var _React$useState3 = react.useState(''),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    chars = _React$useState4[0],
    setChars = _React$useState4[1];
  var questionInput = react.useRef(null);
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe,
    publish = _usePublisher.publish;
  var writeEvent = 'question:write';
  var handleWrite = function handleWrite(e) {
    setChars(e.target.value);
  };
  var handleEdit = function handleEdit() {
    if (questionInput == null ? void 0 : questionInput.current) {
      questionInput.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      questionInput.current.focus();
    }
  };
  var handleClean = function handleClean() {
    return setChars('');
  };
  react.useEffect(function () {
    subscribe('question-confirm:clean', handleClean);
    subscribe('question:edit', handleEdit);
    subscribe(writeEvent, handleWrite);
    return function () {
      unsubscribe('question-confirm:clean', handleClean);
      unsubscribe('question:edit', handleEdit);
      unsubscribe(writeEvent, handleWrite);
    };
  }, [chars]);
  var handleSeeMoreClick = function handleSeeMoreClick(e) {
    var _data$product;
    publish('question-form:see-more', {
      label: seeMore.text,
      userId: userData.id
    });
    e.preventDefault();
    (0,build_esm/* routePush */.dY)({
      path: "/q/a/".concat(data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.variationId, "/").concat(slug, "/").concat(categoryId, "/").concat(subCategoryId),
      spa: true
    });
  };
  var showInput = alwaysShow || totalQuestions <= limit;
  var buttonLabel = userData.isLogged ? buttonText.authenticated : buttonText.unauthenticated;
  var _useQuestionInputVali = (0,hooks/* useQuestionInputValidation */.zq)(chars, {
      maxChars: inputHelper.limit
    }),
    message = _useQuestionInputVali.message,
    textColor = _useQuestionInputVali.textColor,
    inputValid = _useQuestionInputVali.valid;
  var buttonDisabled = showInput && !inputValid;
  return react.createElement(react.Fragment, null, react.createElement("form", null, react.createElement(react.Fragment, null, showInput && react.createElement(react.Fragment, null, react.createElement(Text/* default */.Z, {
    fontSize: [1, 1, 2, 2],
    color: "text.dark",
    fontWeight: "medium",
    my: 3
  }, emptyTitle), userData.isLogged && react.createElement(react.Fragment, null, react.createElement(Box/* default */.Z, {
    mb: 2
  }, react.createElement(HiddenLabel/* default */.Z, {
    title: "digite sua pergunta abaixo",
    htmlFor: "question-input"
  }), react.createElement(Input/* default */.Z, {
    type: "text",
    "data-testid": "publish-new-question",
    id: "question-input",
    hasError: chars.length > 0 && !inputValid,
    onChange: function onChange(e) {
      debounce_default()(function (ev) {
        publish(writeEvent, ev);
      }, bounceWrite)(e);
      setChars(e.target.value);
    },
    value: chars,
    placeholder: "Escreva aqui sua d\xFAvida...",
    multiline: true,
    ref: questionInput
  })), react.createElement(Text/* default */.Z, {
    fontSize: [0, 0, 1, 1],
    color: textColor,
    mb: 4,
    mx: 2
  }, message))), (alwaysShow || totalQuestions <= limit) && react.createElement(Button/* default */.Z, {
    "data-testid": "button-submit-question",
    full: buttonText.full,
    variation: buttonText.variation,
    color: buttonText.color,
    centered: true,
    disabled: buttonDisabled && userData.isLogged,
    onClick: function onClick(e) {
      e.preventDefault();
      publish('question:form:submit', {
        event: e,
        label: buttonLabel,
        logged: userData.isLogged,
        userId: userData.id
      });
    }
  }, buttonLabel))), seeMore.show && totalQuestions > limit && react.createElement(Flex/* default */.Z, {
    alignItems: "center",
    justifyContent: "center"
  }, react.createElement(Link/* default */.Z, {
    "data-testid": "see-more-questions",
    fontWeight: "medium",
    color: "text.primary",
    href: "".concat(domain, "/q/a/").concat(data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : _data$product2.variationId, "/").concat(slug, "/").concat(categoryId, "/").concat(subCategoryId),
    onClick: handleSeeMoreClick
  }, "".concat(seeMore.text))));
};
 false ? 0 : void 0;
QuestionForm.defaultProps = {
  data: {},
  "static": {},
  structure: {
    config: {}
  }
};
/* harmony default export */ var QuestionForm_QuestionForm = ((0,withLayoutProps/* default */.Z)(QuestionForm));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuestionForm/index.js


/***/ }),

/***/ 79465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ QuestionList_QuestionList; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/formatDateDistance/index.js + 1 modules
var formatDateDistance = __webpack_require__(41544);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var utils_build_esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/hooks/useUserData.js
var useUserData = __webpack_require__(16666);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuestionList/QuestionList.styles.js


var _templateObject, _templateObject2;



var QuestionContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  &:not(:last-child) {\n    border-bottom: 1px solid #eee;\n  }\n"])));
var TextQuestionAndAnswer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  word-break: break-word;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuestionList/QuestionList.js


function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }













var QuestionList = function QuestionList(_ref) {
  var staticProps = _ref["static"],
    structure = _ref.structure,
    data = _ref.data;
  var elemRef = (0,react.useRef)(null);
  var title = staticProps.title,
    emptyPhrase = staticProps.emptyPhrase,
    marginBottomScroll = staticProps.marginBottomScroll;
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe,
    publish = _usePublisher.publish;
  var getUserData = react.useCallback((0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
    var response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0,useUserData/* default */.Z)({
            structure: structure
          });
        case 2:
          response = _context.sent;
          publish('question-list:impression', {
            userId: response.id
          });
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), []);
  react.useEffect(function () {
    getUserData();
  }, [getUserData]);
  var _ref3 = data.questions || {},
    questions = _ref3.items,
    totalQuestions = _ref3.totalQuestions;
  var handleQuestionsClick = function handleQuestionsClick() {
    return (0,utils_build_esm/* scrollToRef */.BC)(elemRef, marginBottomScroll);
  };
  (0,react.useEffect)(function () {
    subscribe('product:questions:click', handleQuestionsClick);
    return function () {
      unsubscribe('product:questions:click', handleQuestionsClick);
    };
  });
  var ListQuestions = function ListQuestions(_ref4) {
    var _ref4$questionsList = _ref4.questionsList,
      questionsList = _ref4$questionsList === void 0 ? [] : _ref4$questionsList;
    if (questionsList.length === 0) return react.createElement(Text/* default */.Z, {
      as: "h3",
      "data-testid": "empty-questions",
      fontSize: [1, 1, 2, 2],
      color: "text.light",
      mt: 3,
      mb: 4
    }, emptyPhrase);
    return react.createElement(react.Fragment, null, react.createElement(Text/* default */.Z, {
      color: "text.light",
      lineHeight: "display",
      fontSize: [1, 1, 2, 2],
      mt: 3,
      mb: 2
    }, "".concat(totalQuestions, " perguntas respondidas")), react.createElement(Box/* default */.Z, null, questionsList.map(function (_ref5) {
      var question = _ref5.question,
        id = _ref5.id,
        answer = _ref5.answer,
        answerCreatedAt = _ref5.answerCreatedAt;
      return react.createElement(QuestionContainer, {
        key: id
      }, react.createElement(Box/* default */.Z, {
        py: 2,
        m: 3,
        minHeight: "100px",
        "data-testid": "question",
        maxWidth: "600px"
      }, react.createElement(Text/* default */.Z, {
        as: "h3",
        fontWeight: "medium",
        fontSize: [2, 2, 3, 3],
        mb: 2,
        lineHeight: "display"
      }, question), react.createElement(Flex/* default */.Z, {
        my: 3,
        mx: 0
      }, react.createElement(esm/* Icon */.JO$, {
        name: "ArrowDownRight",
        width: 24,
        height: 24
      }), react.createElement(TextQuestionAndAnswer, {
        fontSize: [1, 1, 2, 2],
        lineHeight: "display"
      }, answer)), react.createElement(Text/* default */.Z, {
        color: "text.light",
        fontSize: [0, 0, 1, 1],
        "data-testid": "answer-date",
        ml: 3,
        my: 2,
        textTransform: "capitalize"
      }, (0,formatDateDistance/* default */.Z)(new Date(answerCreatedAt), new Date()))));
    })));
  };
  return react.createElement(Box/* default */.Z, {
    ref: elemRef,
    yOffset: marginBottomScroll
  }, react.createElement(Heading/* default */.Z, {
    as: "h2",
    color: "base",
    fontSize: 5,
    fontWeight: "medium",
    my: [2, 2, 3, 3]
  }, title), react.createElement(ListQuestions, {
    questionsList: questions
  }));
};
 false ? 0 : void 0;
QuestionList.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
QuestionList.ssr = true;
/* harmony default export */ var QuestionList_QuestionList = ((0,withLayoutProps/* default */.Z)(QuestionList));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuestionList/index.js


/***/ }),

/***/ 32096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ QuickClickCard_QuickClickCard; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/currencyFormatter/index.js
var currencyFormatter = __webpack_require__(93837);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var utils_build_esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../modules/build/esm/commons/index.js + 2 modules
var commons = __webpack_require__(26334);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuickClickCard/constants.js
var actionButtonRenderMap = {
  'showcase.quickclick': false,
  'showcase.quickclick.button': true
};
var actionTypesRenderMap = ['add_item_to_cart', 'view_cart'];
var useInViewConfig = {
  delay: 1000,
  threshold: 0.5,
  triggerOnce: true
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuickClickCard/QuickClickCard.utils.js


function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }



var formatQuantity = function formatQuantity(quantity) {
  if (!quantity || quantity == null) return '1';
  var isNumber = !Number.isNaN(Number(quantity));
  return isNumber ? String(quantity) : '1';
};
var getHighestPriorityTag = function getHighestPriorityTag(shippingTag) {
  var cost = shippingTag.cost,
    time = shippingTag.time,
    complement = shippingTag.complement;
  return cost && {
    content: cost,
    testId: 'shipping-description-cost'
  } || time && {
    content: time,
    testId: 'shipping-description-time'
  } || complement && {
    content: complement,
    testId: 'shipping-description-complement'
  };
};
var handleAddToCart = function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee(_ref) {
    var addToCart, cartExtensions, cartUrl, channel, location, product, productId, publish, quantity, sellerId, ML2_SID, MLPARCEIRO, cartId, partnerId, variables, _yield$addToCart, cartData, error, cartInfo;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          addToCart = _ref.addToCart, cartExtensions = _ref.cartExtensions, cartUrl = _ref.cartUrl, channel = _ref.channel, location = _ref.location, product = _ref.product, productId = _ref.productId, publish = _ref.publish, quantity = _ref.quantity, sellerId = _ref.sellerId;
          ML2_SID = utils_build_esm/* cookiesConstants.ML2_SID */.VD.ML2_SID, MLPARCEIRO = utils_build_esm/* cookiesConstants.MLPARCEIRO */.VD.MLPARCEIRO;
          cartId = (0,utils_build_esm/* getCookie */.ej)(ML2_SID);
          partnerId = (0,utils_build_esm/* getCookie */.ej)(MLPARCEIRO) || '0';
          variables = {
            extensions: cartExtensions,
            id: cartId,
            partnerId: partnerId,
            productId: productId,
            quantity: quantity,
            sellerId: sellerId,
            services: []
          };
          _context.next = 7;
          return addToCart(variables);
        case 7:
          _yield$addToCart = _context.sent;
          cartData = _yield$addToCart.data;
          error = _yield$addToCart.error;
          cartInfo = {
            cartId: cartData == null ? void 0 : cartData.cartId,
            cartUrl: cartUrl
          };
          (0,commons/* buildCartUrlAndRedirect */.lQ)(utils_build_esm/* cartRedirect */._V, publish)({
            cartInfo: cartInfo,
            channel: channel,
            error: error,
            location: location,
            product: product,
            typeButton: commons/* ONE_TOUCH */.$1
          });
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function handleAddToCart(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var isCardWithButton = function isCardWithButton(_ref3) {
  var _actionButtonRenderMa;
  var button = _ref3.button,
    designTokenId = _ref3.designTokenId;
  if (!designTokenId || !button) return false;
  var action = button.action,
    label = button.label;
  if (!action || !label) return false;
  var isMappedActionType = actionTypesRenderMap.includes(action);
  if (!isMappedActionType) return false;
  return (_actionButtonRenderMa = actionButtonRenderMap[designTokenId]) !== null && _actionButtonRenderMa !== void 0 ? _actionButtonRenderMa : false;
};
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuickClickCard/QuickClickCard.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;




var BestPrice = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    fontSize: 3
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: #1e2428;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0%;\n  line-height: 16px;\n  margin-right: 2px;\n\n  ", " {\n    font-size: 24px;\n  }\n"])), (0,stereo_ui_styles_build_esm/* getMediaQuery */.aK)('medium'));
var Button = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: 'primary',
    variation: 'outline'
  }, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: 8px;\n  box-sizing: border-box;\n  max-height: 24px;\n  min-width: 94px;\n\n  ", " {\n    font-size: ", "px;\n    max-height: 40px;\n  }\n\n  > label {\n    font-size: 10px;\n    font-weight: 600;\n    line-height: 16px;\n    text-transform: initial !important;\n\n    ", " {\n      font-size: ", "px;\n    }\n  }\n"])), (0,stereo_ui_styles_build_esm/* getMediaQuery */.aK)('medium'), (0,stereo_ui_styles_build_esm/* themeGet */.R)("fontSizes.0"), (0,stereo_ui_styles_build_esm/* getMediaQuery */.aK)('medium'), (0,stereo_ui_styles_build_esm/* themeGet */.R)("fontSizes.2"));
var CardContent = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var CardHeader = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var Container = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: ", ";\n  border: 1px solid #d3dadd;\n  border-radius: 8px;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  max-width: 116px;\n  padding: 4px;\n  width: 100%;\n\n  &:hover,\n  &:active {\n    border: 1px solid #d3dadd;\n  }\n\n  &:focus-visible {\n    outline: 3px solid #0086ff;\n    outline-offset: 2px;\n    box-shadow: 0 0 0 3px rgba(0, 134, 255, 0.3);\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n\n  ", " {\n    min-height: 330px;\n    max-width: 264px;\n    padding: 16px;\n  }\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm/* getBackgroundColor */.dF)('white')(props);
}, (0,stereo_ui_styles_build_esm/* getMediaQuery */.aK)('medium'));
var Image = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Image */.Ee)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-height: 58px;\n  max-width: 95px;\n  object-fit: contain;\n  width: auto;\n\n  ", " {\n    min-height: 155px;\n    max-width: 190px;\n  }\n"])), (0,stereo_ui_styles_build_esm/* getMediaQuery */.aK)('medium'));
var ImageContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  margin-top: 4px;\n  max-height: 58px;\n  position: relative;\n\n  ", " {\n    max-height: 155px;\n  }\n"])), (0,stereo_ui_styles_build_esm/* getMediaQuery */.aK)('medium'));
var OfferTimer = (0,styled_components_browser_esm/* default */.ZP)(molecules/* OfferTimer */.dV)(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: 4px;\n  margin-right: 0;\n  margin-top: 0;\n  width: 100%;\n\n  & > p {\n    font-size: 10px;\n    font-weight: 500;\n    letter-spacing: -1%;\n    line-height: 12px;\n  }\n\n  & > svg {\n    display: none;\n  }\n\n  ", " {\n    height: 26px;\n\n    & > svg {\n      display: inherit;\n    }\n\n    & > p {\n      font-size: ", "px;\n    }\n  }\n"])), (0,stereo_ui_styles_build_esm/* getMediaQuery */.aK)('medium'), (0,stereo_ui_styles_build_esm/* themeGet */.R)("fontSizes.1"));
var OfferTimerContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  width: 100%;\n"])));
var Price = styled_components_browser_esm/* default.div */.ZP.div(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: baseline;\n  color: #1e2428;\n  display: flex;\n  margin-bottom: 3px;\n  margin-top: 4px;\n  max-height: 92px;\n\n  ", " {\n    max-height: fit-content;\n    margin: 12px 0px;\n  }\n"])), (0,stereo_ui_styles_build_esm/* getMediaQuery */.aK)('medium'));
var ProductTitle = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(_templateObject11 || (_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  -webkit-box-orient: vertical; /* stylelint-disable-line property-no-vendor-prefix */\n  -webkit-line-clamp: 2; /* stylelint-disable-line property-no-vendor-prefix */\n  color: #697277;\n  display: -webkit-box; /* stylelint-disable-line value-no-vendor-prefix */\n  font-size: 10px;\n  font-weight: 400;\n  letter-spacing: 0%;\n  line-height: 12px;\n  margin-top: 4px;\n  max-height: 3em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n\n  ", " {\n    font-size: ", "px;\n    line-height: 1.25;\n  }\n"])), (0,stereo_ui_styles_build_esm/* getMediaQuery */.aK)('medium'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.1'));
var ShippingDescription = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv).attrs(function () {
  return {
    fontWeight: 'regular'
  };
})(_templateObject12 || (_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: #0086ff;\n  font-size: ", "px;\n"])), (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.0'));
var ShippingTag = styled_components_browser_esm/* default.div */.ZP.div(_templateObject13 || (_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  > p:first-of-type {\n    margin-top: 0;\n  }\n"])));
var TagCouponContainer = styled_components_browser_esm/* default.span */.ZP.span(_templateObject14 || (_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  & > * {\n    font-size: 0.7rem;\n\n    ", " {\n      font-size: ", "px;\n    }\n  }\n"])), (0,stereo_ui_styles_build_esm/* getMediaQuery */.aK)('medium'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.0'));
var Title = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv)(_templateObject15 || (_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: #1e2428;\n  font-size: 10px;\n  font-weight: 500;\n  letter-spacing: 0%;\n  line-height: 18px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", " {\n    font-size: ", "px;\n  }\n"])), (0,stereo_ui_styles_build_esm/* getMediaQuery */.aK)('medium'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.3'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuickClickCard/QuickClickCardFooter.js





var QuickClickCardFooter = function QuickClickCardFooter(_ref) {
  var button = _ref.button,
    hasActionButton = _ref.hasActionButton,
    shippingTag = _ref.shippingTag,
    rating = _ref.rating,
    restrictions = _ref.restrictions,
    tagCoupon = _ref.tagCoupon;
  var highestPriorityShippingTag = getHighestPriorityTag(shippingTag);
  if (button && hasActionButton) {
    return react.createElement(Button, {
      "data-testid": "quickclickcard-button",
      full: true,
      tabIndex: "-1",
      "aria-label": button.label
    }, button.label);
  }
  if (restrictions && restrictions.timer_end_date && restrictions.timer_start_date) {
    return react.createElement(OfferTimerContainer, {
      "data-testid": "quickclickcard-offertimer-container"
    }, react.createElement(OfferTimer, {
      restrictions: {
        timer_end_date: restrictions.timer_end_date,
        timer_start_date: restrictions.timer_start_date
      },
      text: "Termina em"
    }));
  }
  if (tagCoupon) {
    return react.createElement(TagCouponContainer, null, react.createElement(molecules/* TagCoupon */.rE, {
      showIcon: false,
      mt: 1,
      tags: tagCoupon
    }));
  }
  if (highestPriorityShippingTag) {
    return react.createElement(ShippingTag, null, react.createElement(ShippingDescription, {
      "data-testid": highestPriorityShippingTag.testId
    }, highestPriorityShippingTag.content));
  }
  if (rating && !!(rating == null ? void 0 : rating.score)) {
    return react.createElement(molecules/* Review */.Cq, {
      count: rating.count,
      score: rating.score,
      width: "12px",
      height: "12px"
    });
  }
  return null;
};
 false ? 0 : void 0;
QuickClickCardFooter.defaultProps = {
  button: null,
  hasActionButton: false,
  rating: null,
  restrictions: null,
  shippingTag: {
    complement: null,
    cost: null,
    time: null
  },
  tagCoupon: null
};
/* harmony default export */ var QuickClickCard_QuickClickCardFooter = (QuickClickCardFooter);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuickClickCard/QuickClickCard.js












var QuickClickCard = function QuickClickCard(_ref) {
  var button = _ref.button,
    cartExtensions = _ref.cartExtensions,
    cartUrl = _ref.cartUrl,
    clickEvent = _ref.clickEvent,
    designTokenId = _ref.designTokenId,
    image = _ref.image,
    location = _ref.location,
    minimumOrderQuantity = _ref.minimumOrderQuantity,
    path = _ref.path,
    price = _ref.price,
    product = _ref.product,
    productId = _ref.productId,
    productTitle = _ref.productTitle,
    rating = _ref.rating,
    restrictions = _ref.restrictions,
    salesChannelId = _ref.salesChannelId,
    sellerId = _ref.sellerId,
    shippingTag = _ref.shippingTag,
    tagCoupon = _ref.tagCoupon,
    title = _ref.title,
    viewEvent = _ref.viewEvent;
  var _useCart = (0,esm.useCart)(),
    _useCart2 = (0,slicedToArray/* default */.Z)(_useCart, 1),
    addToCart = _useCart2[0].addToCart;
  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)(useInViewConfig),
    _useInView2 = (0,slicedToArray/* default */.Z)(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var bestPrice = price.bestPrice;
  var formattedBestPrice = (0,currencyFormatter/* default */.Z)({
    value: bestPrice
  });
  var hasActionButton = isCardWithButton({
    button: button,
    designTokenId: designTokenId
  });
  var handleClick = function handleClick(event) {
    event.preventDefault();
    clickEvent();
    if (!hasActionButton) {
      (0,utils_build_esm/* routePush */.dY)({
        path: path,
        spa: false
      });
      return;
    }
    if (button.action.includes('view_cart')) {
      (0,utils_build_esm/* cartRedirect */._V)({
        cartUrl: cartUrl
      });
      return;
    }
    if (button.action.includes('add_item_to_cart')) {
      handleAddToCart({
        addToCart: addToCart,
        cartExtensions: cartExtensions,
        cartUrl: cartUrl,
        channel: salesChannelId,
        location: location,
        product: product,
        productId: productId,
        publish: publish,
        quantity: formatQuantity(minimumOrderQuantity),
        sellerId: sellerId
      });
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick(event);
    }
  };
  (0,react.useEffect)(function () {
    if (inView) viewEvent();
  }, [inView]);
  return react.createElement(Container, {
    lang: "pt-BR",
    "aria-labelledby": "titulo-".concat(productId, " preco-").concat(productId),
    "data-testid": "quickclickcard-".concat(productId),
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    role: "button",
    tabIndex: "0",
    ref: ref
  }, react.createElement(CardHeader, null, react.createElement(Title, {
    as: "h3",
    id: "titulo-".concat(productId)
  }, title), react.createElement(ImageContainer, null, react.createElement(Image, {
    src: image,
    lazy: true,
    alt: "Foto do produto ".concat(productTitle),
    "aria-hidden": "false"
  }))), react.createElement(CardContent, null, react.createElement(ProductTitle, {
    id: "descricao-".concat(productId),
    "data-testid": "quickclickcard-product-title"
  }, productTitle), react.createElement(Price, {
    id: "preco-".concat(productId)
  }, react.createElement(BestPrice, {
    as: "h4",
    "aria-label": "Valor: ".concat(formattedBestPrice)
  }, formattedBestPrice)), react.createElement(QuickClickCard_QuickClickCardFooter, {
    button: button,
    hasActionButton: hasActionButton,
    rating: rating,
    restrictions: restrictions,
    shippingTag: shippingTag,
    tagCoupon: tagCoupon
  })));
};
 false ? 0 : void 0;
QuickClickCard.defaultProps = {
  button: null,
  cartExtensions: false,
  clickEvent: function clickEvent() {},
  location: null,
  minimumOrderQuantity: '1',
  price: null,
  rating: null,
  restrictions: null,
  salesChannelId: '',
  shippingTag: {
    complement: null,
    cost: null,
    time: null
  },
  tagCoupon: null,
  viewEvent: function viewEvent() {}
};
/* harmony default export */ var QuickClickCard_QuickClickCard = (QuickClickCard);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuickClickCard/index.js


/***/ }),

/***/ 11394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ QuickClickShowcase_QuickClickShowcase; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/config.js
var config = __webpack_require__(70314);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/QuickClickCard/index.js + 5 modules
var QuickClickCard = __webpack_require__(32096);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var utils_build_esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../modules/build/esm/commons/constants.js
var constants = __webpack_require__(88338);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuickClickShowcase/QuickClickShowcase.utils.js



var ML2_SID = utils_build_esm/* cookiesConstants.ML2_SID */.VD.ML2_SID;
var getCustomerId = function getCustomerId(structure) {
  var _structure$cookies, _structure$cookies$ac, _structure$cookies2;
  var CUSTOMER_ID = utils_build_esm/* cookiesConstants.CUSTOMER_ID */.VD.CUSTOMER_ID;
  var structureCustomerId = (structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.id) || (structure == null ? void 0 : (_structure$cookies2 = structure.cookies) == null ? void 0 : _structure$cookies2.customerId);
  return structureCustomerId || (0,utils_build_esm/* getCookie */.ej)(CUSTOMER_ID) || 'unknown';
};
var hasMinimalRecommendations = function hasMinimalRecommendations(showcases, minShowcases) {
  return !!(showcases == null ? void 0 : showcases.length) && (showcases == null ? void 0 : showcases.length) >= minShowcases;
};
var parseQuickClickData = function parseQuickClickData(quickClickData) {
  var _structure$cookies3, _structure$cookies3$a;
  var _ref = quickClickData || {},
    cartExtensions = _ref.cartExtensions,
    publish = _ref.publish,
    showcaseArr = _ref.showcaseArr,
    structure = _ref.structure;
  var customerId = structure == null ? void 0 : (_structure$cookies3 = structure.cookies) == null ? void 0 : (_structure$cookies3$a = _structure$cookies3.accountData) == null ? void 0 : _structure$cookies3$a.id;
  var pageName = structure == null ? void 0 : structure.name;
  if (!showcaseArr || !Array.isArray(showcaseArr)) return [];
  var parsedData = [];
  showcaseArr.forEach(function (showcase, index) {
    var _structure$config, _structure$config2, _product$seller;
    var button = showcase.button,
      designTokenId = showcase.designTokenId,
      products = showcase.products,
      title = showcase.title;
    if (!Array.isArray(products) || !(products == null ? void 0 : products.length)) {
      return;
    }
    var product = products[0];
    var productId = product.id,
      image = product.image,
      minimumOrderQuantity = product.minimumOrderQuantity,
      path = product.path,
      price = product.price,
      rating = product.rating,
      restrictions = product.restrictions,
      seller = product.seller,
      shippingTag = product.shippingTag,
      productTitle = product.title;
    var eventData = {
      available: true,
      display: 'gallery',
      index: index,
      list: title,
      listPosition: index,
      origin: 'bob',
      position: index + 1,
      showcase: showcase,
      type: 'recomendacao'
    };
    var _ref2 = button || {},
      buttonAction = _ref2.action,
      buttonLabel = _ref2.label;
    var handleQuickShowcaseClick = function handleQuickShowcaseClick() {
      if (buttonAction == null ? void 0 : buttonAction.includes('add_item_to_cart')) {
        var cartId = (0,utils_build_esm/* getCookie */.ej)(ML2_SID);
        publish('product:addToCart', {
          cartId: cartId,
          customer_id: customerId,
          pageName: pageName,
          product: (0,esm_extends/* default */.Z)({}, product, {
            shipping: []
          }),
          typeButton: constants/* ADD_TO_BAG */.wO
        });
        return;
      }
      publish('product:quickClickSelectItem', (0,esm_extends/* default */.Z)({
        buttonLabel: buttonLabel,
        customer_id: customerId,
        pageName: pageName,
        trackingUrl: product.url
      }, product, eventData));
    };
    var onShowCaseView = function onShowCaseView() {
      publish('product:quickClickViewItemList', (0,esm_extends/* default */.Z)({
        buttonLabel: buttonLabel,
        customer_id: customerId,
        pageName: pageName
      }, product, eventData));
    };
    parsedData.push({
      button: button,
      cartExtensions: cartExtensions,
      cartUrl: structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.cartUrl,
      clickEvent: handleQuickShowcaseClick,
      designTokenId: designTokenId,
      image: image,
      location: structure == null ? void 0 : structure.location,
      minimumOrderQuantity: minimumOrderQuantity,
      path: path,
      price: price,
      product: product,
      productId: productId,
      productTitle: productTitle,
      rating: rating,
      restrictions: restrictions,
      salesChannelId: structure == null ? void 0 : (_structure$config2 = structure.config) == null ? void 0 : _structure$config2.salesChannelId,
      sellerId: seller.id,
      shippingTag: shippingTag,
      tagCoupon: (0,utils_build_esm/* getCouponData */.jF)(product == null ? void 0 : (_product$seller = product.seller) == null ? void 0 : _product$seller.tags),
      title: title,
      viewEvent: onShowCaseView
    });
  });
  return parsedData;
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuickClickShowcase/QuickClickShowcase.js











var QuickClickShowcase = function QuickClickShowcase(_ref) {
  var _publicRuntimeConfig$;
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var _getConfig = config_default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;
  var timeout = publicRuntimeConfig == null ? void 0 : (_publicRuntimeConfig$ = publicRuntimeConfig.recommendation) == null ? void 0 : _publicRuntimeConfig$.timeout;
  var _useState = (0,react.useState)([]),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    showcases = _useState2[0],
    setShowcases = _useState2[1];
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var customerId = getCustomerId(structure);
  var _ref2 = (structure == null ? void 0 : structure.cookies) || {},
    location = _ref2.location,
    trackId = _ref2.trackId;
  var extensions = staticProps.extensions,
    maxLengthShowcases = staticProps.maxLengthShowcases,
    minLengthShowcases = staticProps.minLengthShowcases,
    pageId = staticProps.page,
    partnerId = staticProps.partnerId,
    placeId = staticProps.placement,
    styles = staticProps.styles;
  var _useShowcase = (0,build_esm.useShowcase)({
      customerId: customerId,
      options: {
        timeout: timeout
      },
      pageId: pageId,
      partnerId: partnerId,
      placeId: placeId,
      trackId: trackId,
      withButtonAction: true,
      zipCode: location == null ? void 0 : location.zipCode
    }),
    recommendation = _useShowcase.recommendation;
  var shouldRenderShowcase = hasMinimalRecommendations(recommendation, minLengthShowcases);
  (0,react.useEffect)(function () {
    if (shouldRenderShowcase) {
      setShowcases(parseQuickClickData({
        cartExtensions: extensions,
        publish: publish,
        showcaseArr: recommendation,
        structure: structure
      }));
    }
  }, [recommendation, shouldRenderShowcase, trackId]);
  return react.createElement(react.Fragment, null, shouldRenderShowcase ? react.createElement(Flex/* default */.Z, (0,esm_extends/* default */.Z)({
    "data-testid": "quickclick-showcase"
  }, styles), showcases == null ? void 0 : showcases.slice(0, maxLengthShowcases).map(function (showcase) {
    return react.createElement(QuickClickCard/* default */.Z, (0,esm_extends/* default */.Z)({
      key: "quickclick-card-".concat(showcase.productId)
    }, showcase));
  })) : null);
};
 false ? 0 : void 0;
QuickClickShowcase.defaultProps = {
  "static": {
    extensions: false,
    maxLengthShowcases: 10,
    minLengthShowcases: 5,
    styles: {}
  },
  structure: {}
};
QuickClickShowcase.ssr = true;
/* harmony default export */ var QuickClickShowcase_QuickClickShowcase = ((0,withLayoutProps/* default */.Z)(QuickClickShowcase));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/QuickClickShowcase/index.js


/***/ }),

/***/ 98935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Rating_Rating; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Review/index.js + 2 modules
var Review = __webpack_require__(73172);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Rating/Rating.js





var Rating = function Rating(_ref) {
  var _productRating$genera, _review$stats, _productRating$genera2, _review$stats2;
  var _ref$data = _ref.data,
    productRating = _ref$data.productRating,
    review = _ref$data.review,
    StaticProps = _ref["static"];
  var eventClick = StaticProps.eventClick;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var rating = {
    count: (productRating == null ? void 0 : (_productRating$genera = productRating.general) == null ? void 0 : _productRating$genera.reviewCount) || (review == null ? void 0 : (_review$stats = review.stats) == null ? void 0 : _review$stats.count) || 0,
    score: (productRating == null ? void 0 : (_productRating$genera2 = productRating.general) == null ? void 0 : _productRating$genera2.rating) || (review == null ? void 0 : (_review$stats2 = review.stats) == null ? void 0 : _review$stats2.average) || 0
  };
  return react.createElement(Review/* default */.Z, {
    count: rating == null ? void 0 : rating.count,
    score: rating == null ? void 0 : rating.score,
    width: "20px",
    height: "20px",
    fontSize: "12px",
    cursor: "pointer",
    format: "score-count",
    onClick: function onClick() {
      return publish(eventClick);
    }
  });
};
 false ? 0 : void 0;
Rating.defaultProps = {
  data: {},
  "static": {}
};
Rating.dataSource = {
  productRating: {
    query: 'ProductRatingQuery'
  },
  review: {
    query: 'ReviewQuery'
  }
};
Rating.ssr = true;
/* harmony default export */ var Rating_Rating = ((0,withLayoutProps/* default */.Z)(Rating));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Rating/index.js


/***/ }),

/***/ 53344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _magalu_stereo_ui_molecules_RatingLine__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11151);
/* harmony import */ var _magalu_stereo_ui_atoms_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63825);
/* harmony import */ var _magalu_stereo_ui_atoms_Flex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19527);






var RatingLineGroup = function RatingLineGroup(_ref) {
  var staticProps = _ref["static"],
    layout = _ref.layout,
    data = _ref.data;
  var title = staticProps.title,
    isMobile = staticProps.isMobile;
  var widthLinearRating = layout.widthLinearRating,
    widthRating = layout.widthRating,
    columnGapRating = layout.columnGapRating,
    heightProgressRating = layout.heightProgressRating,
    columnGapRatingLineGroup = layout.columnGapRatingLineGroup,
    scoreFontSizeRating = layout.scoreFontSizeRating,
    starSizeRating = layout.starSizeRating;
  var _ref2 = data.productRating || {},
    _ref2$reviewsByRating = _ref2.reviewsByRating,
    reviewsByRating = _ref2$reviewsByRating === void 0 ? [] : _ref2$reviewsByRating,
    _ref2$general = _ref2.general,
    general = _ref2$general === void 0 ? {} : _ref2$general;
  var _ref3 = general || {},
    reviewCount = _ref3.reviewCount;
  var sortedReviewsByRating = (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(reviewsByRating).sort(function (a, b) {
    return b.rating - a.rating;
  });
  return !!(sortedReviewsByRating == null ? void 0 : sortedReviewsByRating.length) && !!reviewCount && react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, !isMobile && react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui_atoms_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    py: 3,
    as: "h2",
    fontWeight: "medium",
    fontSize: 1
  }, title), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui_atoms_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    "data-testid": "rating-line-container",
    flexDirection: "column",
    gap: columnGapRatingLineGroup
  }, sortedReviewsByRating.map(function (item) {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui_molecules_RatingLine__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      key: item.rating,
      count: (item == null ? void 0 : item.total) <= 999 ? "".concat(item == null ? void 0 : item.total) : '+999',
      id: item == null ? void 0 : item.rating,
      max: reviewCount,
      score: item == null ? void 0 : item.total,
      starColor: "#FFCC03",
      lineColor: "#0086ff",
      fontweightScore: "bold",
      heightProgress: heightProgressRating,
      columnGap: columnGapRating,
      width: widthRating,
      starSize: starSizeRating,
      scoreFontSize: scoreFontSizeRating,
      widthProgress: widthLinearRating,
      countColor: "black",
      pointerNone: true
    });
  })));
};
RatingLineGroup.defaultProps = {
  data: {
    productRating: {
      reviewsByRating: []
    }
  },
  layout: {
    scoreFontSizeRating: 1,
    widthLinearRating: '70px',
    widthRating: 40
  },
  "static": {
    isMobile: true,
    title: ''
  }
};
 false ? 0 : void 0;
RatingLineGroup.ssr = true;
/* harmony default export */ __webpack_exports__["Z"] = (RatingLineGroup);

/***/ }),

/***/ 71956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _RatingLineGroup__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _RatingLineGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53344);


/***/ }),

/***/ 5837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ RatingPlusScore_RatingPlusScore; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/RatingLineGroup/RatingLineGroup.js
var RatingLineGroup = __webpack_require__(53344);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ReviewTotalizers/index.js + 1 modules
var ReviewTotalizers = __webpack_require__(77137);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/RatingPlusScore/RatingPlusScore.js





var RatingPlusScore = function RatingPlusScore(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"],
    layout = _ref.layout;
  var _ref2 = data.productRating || {},
    _ref2$reviewsByRating = _ref2.reviewsByRating,
    reviewsByRating = _ref2$reviewsByRating === void 0 ? [] : _ref2$reviewsByRating,
    _ref2$general = _ref2.general,
    general = _ref2$general === void 0 ? {} : _ref2$general;
  var _ref3 = general || {},
    reviewCount = _ref3.reviewCount;
  var marginComponet = staticProps.marginComponet;
  return !!(reviewsByRating == null ? void 0 : reviewsByRating.length) && !!reviewCount && react.createElement(Flex/* default */.Z, {
    m: marginComponet,
    bg: "background.white",
    "data-testid": "rating-plus-score-container"
  }, react.createElement(ReviewTotalizers["default"], {
    data: data,
    flexDirection: "column",
    showComment: true
  }), react.createElement(RatingLineGroup/* default */.Z, {
    data: data,
    layout: layout
  }));
};
RatingPlusScore.defaultProps = {
  data: {
    productRating: {
      general: [],
      reviewsByRating: []
    }
  },
  layout: {
    widthLinearRating: '70px'
  },
  "static": {
    marginComponet: ''
  }
};
 false ? 0 : void 0;
RatingPlusScore.ssr = true;
/* harmony default export */ var RatingPlusScore_RatingPlusScore = (RatingPlusScore);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/RatingPlusScore/index.js


/***/ })

}]);